import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="streaming-message"
// This controller hides the message until the first chunk of content arrives
export default class extends Controller {
  static targets = ["content"]

  connect() {

    // Set up a MutationObserver to watch for content changes
    this.observer = new MutationObserver((mutations) => {
      this.checkForContent()
    })

    // Observe changes to the content target
    if (this.hasContentTarget) {
      this.observer.observe(this.contentTarget, {
        childList: true,      // Watch for added/removed nodes
        characterData: true,  // Watch for text changes
        subtree: true         // Watch all descendants
      })
    }

    // Check if there's already content (in case of reconnection)
    this.checkForContent()
  }

  disconnect() {
    // Clean up the observer when controller disconnects
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  checkForContent() {
    if (!this.hasContentTarget) return

    // If we have any text content, show the message
    const content = this.contentTarget.textContent.trim()
    if (content.length > 0) {
      this.element.classList.remove('hidden')
      // Stop observing once we've revealed the message
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    }
  }
}
